import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb';
import CustomStepper from '../../../../components/CustomStepper/CustomStepper';
import GroupInformationForm from '../../../../components/Operator/Group/Forms/InformationForm/GroupInformationForm';
import GroupRatesForm from '../../../../components/Operator/Group/Forms/RatesForm/GroupRatesForm';
import GroupBillingForm from '../../../../components/Operator/Group/Forms/Billing/GroupBillingForm';
import './AddGroup.scss';
import { groupInitialValues } from '../../../AddLocation/utils';
import axiosWrapper from '../../../../utils/api';
import { API_URL } from '../../../../utils/apiUrl';
import { useSelector } from 'react-redux';

const AddGroup = () => {
    const { userToken } = useSelector((state) => state.auth);
    // State to track current step
    const [currentStep, setCurrentStep] = useState(0);

    // Step-wise form data
    const [step0Values, setStep0Values] = useState(groupInitialValues.step0);
    const [step1Values, setStep1Values] = useState(groupInitialValues.step1);
    const [step2Values, setStep2Values] = useState(groupInitialValues.step2);
    // New state for locations (zones)
    const [locationOptions, setLocationOptions] = useState([]);
    // Function to navigate between steps
    const changeCurrentStep = (nextStep, conditionalChange = true) => {
        if (conditionalChange) {
            if (nextStep === 0 && currentStep !== 0) {
                setStep0Values((prev) => ({ ...prev, isCompleted: false }));
                setCurrentStep(nextStep);
            } else if (nextStep === 1 && step0Values.isCompleted) {
                setStep1Values((prev) => ({ ...prev, isCompleted: false }));
                setCurrentStep(nextStep);
            } else if (nextStep === 2 && step0Values.isCompleted && step1Values.isCompleted) {
                setStep2Values((prev) => ({ ...prev, isCompleted: false }));
                setCurrentStep(nextStep);
            }
        } else {
            setCurrentStep(nextStep);
        }
    };

    // Fetch locations on mount
    useEffect(() => {
        const fetchLocations = async () => {
            const { data } = await axiosWrapper('GET', API_URL.GET_LOCATIONS, {}, userToken);
            const options = data?.map((location) => ({
                value: location?._id || '',
                label: location?.zone || '',
                recurringRates: location?.recurringRates || [] // This will be used in GroupRatesForm
            }));
            setLocationOptions(options);
        };

        fetchLocations();
    }, []);

    useEffect(() => {
        // Scroll to top when changing steps
        document.getElementById('scrollable-div')?.scrollTo(0, 0);
    }, [currentStep]);
    return (
        <>
            <Helmet>
                <title>Add Group | Level Parking</title>
            </Helmet>
            <BreadCrumb items={[{ label: 'Groups', href: '/admin/groups' }, { label: 'Add Group' }]} />
            <div className="add-group-form-container">
                <CustomStepper currentStep={currentStep} changeCurrentStep={changeCurrentStep} />

                {/* Render Forms Based on Current Step */}
                {currentStep === 0 && <GroupInformationForm {...{ changeCurrentStep, step0Values, setStep0Values }} />}
                {currentStep === 1 && (
                    <GroupRatesForm
                        {...{
                            changeCurrentStep,
                            step1Values,
                            setStep1Values,
                            zoneOptions: locationOptions
                        }}
                    />
                )}
                {currentStep === 2 && (
                    <GroupBillingForm
                        {...{ changeCurrentStep, step2Values, setStep2Values, step1Values, step0Values }}
                    />
                )}
            </div>
        </>
    );
};

export default AddGroup;
